import { styled } from '@mui/material/styles';

export const GradientPage = styled('div')(({ theme }) => ({
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  background: `linear-gradient(to bottom right, ${theme.palette.grey[200]}, ${theme.palette.grey[500]})`,
}));
